let counters: Record<string, number> = {}

/** Deterministic, readable ids like "cus_0001" — stable across reloads so fixtures can cross-reference each other. */
export function nextId(prefix: string): string {
  counters[prefix] = (counters[prefix] ?? 0) + 1
  return `${prefix}_${String(counters[prefix]).padStart(4, '0')}`
}

export function resetIdCounters(): void {
  counters = {}
}
